<template>
  <!-- <base-section id="blog-page">
    <v-container> -->
  <v-col>
    <v-row>
      <v-col cols="12" sm="10" md="9" lg="9">
        <page :content="content" v-if="content" />
      </v-col>
      <v-col cols="12" sm="2" md="3" lg="3">
        <v-list dense>
          <v-list-item-group v-model="selectedBlog" color="primary">
            <v-list-item v-for="(blog, i) in blogs" :key="i">
              <v-list-item-content>
                <router-link :to="'/b/' + blog.value">
                  <v-list-item-title v-text="blog.key"></v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-col>
  <!-- </v-container>
  </base-section> -->
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import Page from "@/views/home/page/Page.vue";

@Component({
  name: "BlogPage",
  components: { Page },
})
export default class BlogPage extends Vue {
  selectedBlog = null;
  content = null;
  blogs = [];
  // pageLink = this.$route.params.link;
  async mounted() {
    if (this.$route.params.link) {
      // this.pageLink = this.$route.params.link;
      this.onLinkChange(this.$route.params.link);
    }
    this.blogs = await doGet("/api/o/screen/7/pages");
  }


  @Watch("$route.params.link")
  async onLinkChange(pageLink) {
    this.content = await doGet("/api/o/screen/7/active?page=" + pageLink);
  }
}
</script>
